module.exports = __webpack_public_path__ + "img/584F3A_BEC3BD_C5A57D_A39073-256px.8d665a1a.png";